// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__NzWAG","noInteraction":"EventWrapper_noInteraction__iFAQl","pointerPassthrough":"EventWrapper_pointerPassthrough__2eigY"};